var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinDropoff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "destinationIconSVG",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "pin_dropoff") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1od9252"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0084E4",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004CC4",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pin_dropoff",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(6.565657, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.0266299,40.8783784 C22.2543618,40.8783784 25.1423324,39.527027 25.4820937,40.2027027 C25.7086012,40.6531532 23.5567799,43.9189189 19.0266299,50 C14.49648,43.9189189 12.3446587,40.6531532 12.5711662,40.2027027 C12.9109275,39.527027 15.7988981,40.8783784 19.0266299,40.8783784 Z M18.6868687,-7.10542736e-15 C29.0073413,-7.10542736e-15 37.3737374,8.31903337 37.3737374,18.5810811 C37.3737374,28.8431288 29.0073413,37.1621622 18.6868687,37.1621622 C8.36639609,37.1621622 3.97903932e-13,28.8431288 3.97903932e-13,18.5810811 C3.97903932e-13,8.31903337 8.36639609,-7.10542736e-15 18.6868687,-7.10542736e-15 Z",
    id: "Combined-Shape",
    fill: "url(#linearGradient-1od9252)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Regular-M",
    transform: "translate(11.616162, 10.606061)",
    fill: "white",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.605144141,15.6565657 C0.93957234,15.6565657 1.21030459,15.3932336 1.21030459,15.0580747 L1.21030459,10.6212568 C1.40936666,10.5334794 2.15783485,10.2461888 3.32833354,10.2461888 C6.27445877,10.2461888 8.12175548,11.6905521 10.9245567,11.6905521 C12.1667092,11.6905521 12.6285293,11.5549066 13.2336735,11.2835828 C13.7830959,11.0362014 14.1414141,10.6212568 14.1414141,9.88710402 L14.1414141,1.78749746 C14.1414141,1.35658596 13.775138,1.10920448 13.3133016,1.10920448 C12.9231353,1.10920448 12.1905993,1.44436332 10.8210385,1.44436332 C8.01823733,1.44436332 6.17889854,0 3.22481539,0 C1.98266283,0 1.51286851,0.135661865 0.907724365,0.406985594 C0.358318257,0.654350728 0,1.06931162 0,1.79548911 C0,5.9080071 0,8.9923956 0,11.0486546 C0,11.9396369 0,13.2761102 0,15.0580747 C0,15.3852583 0.278690166,15.6565657 0.605144141,15.6565657 Z",
    id: "Path"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinDropoff);
export default __webpack_public_path__ + "static/media/pin_dropoff.777fc0a2.svg";
export { ForwardRef as ReactComponent };